export default "__VITE_ASSET__CD0CKjiD__"